import React, { useState, forwardRef, useEffect } from 'react';
import { Modal, Dropdown } from 'react-bootstrap';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';
import { ToastContainer, toast } from "react-toastify";

const ServiceModal = forwardRef((props, ref) => {
    const [inviteModal, setInviteModal] = useState(true);
    const [serviceName, setServiceName] = useState('');
    const [description, setDescription] = useState('');
    const [standardPrice, setStandardPrice] = useState('');
    const [estimatedTime, setEstimatedTime] = useState('');
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [categoryId, setcategoryId] = useState('');

    // Fetching user permissions
    const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
    const userPermissions = JSON.parse(userPermissionsJSON);
    const pageName = 'Garantees';
    const actionsForPage = userPermissions.find(permission => permission.resource === pageName)?.action || [];

    const userDataJSON = localStorage.getItem('USER_data');
    const userData = JSON.parse(userDataJSON);
    const userID = userData.id;

    useEffect(() => {
        fetchServices();
        fetchCategories();
    }, []);
    const [categories, setCategories] = useState([]);
    const fetchCategories = async () => {
        try {
            const response = await axios.get('https://subk.education.com.ly/back/api/getServiceCategory'); // Adjust to your actual API URL
            setCategories(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    }
    const fetchServices = async () => {
        try {
            const response = await axios.get('https://subk.education.com.ly/back/api/services');
            setData(response.data);
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    };

    const handleEdit = async (id, field, value) => {
        try {
            await axios.put(`https://subk.education.com.ly/back/api/services/${id}`, { [field]: value });
            setData(prevData =>
                prevData.map(service => service.ServiceID === id ? { ...service, [field]: value } : service)
            );
        } catch (error) {
            console.error('Error updating service:', error);
        }
    };

    const createService = async (e) => {
        e.preventDefault();

        // Check if any required fields are empty
        if (!serviceName || !standardPrice || !estimatedTime || !categoryId) {
            swal("Error", "Please fill in all fields.", "error");
            return; // Prevent the form from being submitted if fields are empty
        }

        try {
            const newService = {
                ServiceName: serviceName,
                Description: description,
                StandardPrice: standardPrice,
                EstimatedTime: estimatedTime,
                categoryId: categoryId,
                UserID: userID,
                Status: 'Available'
            };

            const response = await axios.post('https://subk.education.com.ly/back/api/services', newService);

            // Checking the status from the response
            if (response.status === 201) {
                toast.success('تم الحفظ بنجاح!');

                fetchServices(); // Refresh the services list
                // Clear form fields
                setServiceName('');
                setDescription('');
                setStandardPrice('');
                setEstimatedTime('');
            } else {
                swal("Error", response.data.message || "An error occurred while creating the service.", "error");
            }
        } catch (error) {
            console.error('Error creating service:', error);
            swal("Error", error.response.data.message || "An error occurred while creating the service.", "error");
        }
    };


    const handleAction = async (id, field, value) => {
        try {
            await axios.put(`https://subk.education.com.ly/back/api/services/${id}`, { [field]: value });
            setData(prevData => prevData.map(service => service.ServiceID === id ? { ...service, Status: value } : service));
        } catch (error) {
            console.error('Error updating status:', error);
        }
    };

    const handleSelect = (eventKey, rowIndex) => {
        const updatedData = [...data];
        updatedData[rowIndex].Status = eventKey;
        handleAction(updatedData[rowIndex].ServiceID, 'Status', eventKey);
    };

    const closeModal = () => {
        setInviteModal(false);
        navigate('/Dashboard_1');
    };

    return (
        <>         <ToastContainer />
            <Modal className="modal fade" size="xl" id="serviceModal" show={inviteModal} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">الخدمات</h1>
                        <button type="button" style={{ marginLeft: 0 }} className="btn-close" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body py-2 px-5">
                        <form onSubmit={createService}>
                            <div className="row">
                                <div className="col-xl-3">
                                    <label className="form-label mt-3"> اسم الخدمة</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={serviceName}
                                        onChange={(e) => setServiceName(e.target.value)}
                                        required
                                    />                             </div>

                                <div className="col-xl-3">
                                    <label className="form-label mt-3">تصنيف</label>
                                    <select className="default-select form-control  ms-1" name="categoryId"
                                        value={categoryId} required
                                        onChange={(e) => setcategoryId(e.target.value)}
                                    >
                                        <option data-display="Select">اختر</option>
                                        {
                                            categories.map((row) => (
                                                <option key={row.servicecategoryID} value={row.servicecategoryID}>
                                                    {row.categoryName}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-xl-3">
                                    <label className="form-label mt-3">سعر الاصلي</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={standardPrice}
                                        onChange={(e) => setStandardPrice(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="col-xl-3">
                                    <label className="form-label mt-3">الوقت الازم</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={estimatedTime}
                                        onChange={(e) => setEstimatedTime(e.target.value)}
                                    />
                                </div>
                            </div>
                            {actionsForPage.includes('create') && (

                                <div className="d-flex justify-content-center">
                                    <button type="submit" className="btn btn-primary mt-3">اضافة خدمة</button>
                                </div>)}               </form>

                        {/* Table for displaying existing services */}
                        <div className="table-responsive active-projects task-table my-2 mx-2 dlab-scroll" style={{ maxHeight: "400px" }}>
                        <table className="table " >
     <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

        <tr>
            <th scope="col">اسم الخدمة</th>
            <th scope="col">تصنيف الخدمة</th>
            <th scope="col">السعر</th>
            <th scope="col">الوقت الازم</th>
            <th scope="col">الحالة</th>
        </tr>
    </thead>
    <tbody>
        {data.length > 0 &&
            data.map((row, key) => (
                <tr key={key}>
                    {/* Editable Service Name */}
                    <td
                        contentEditable={actionsForPage.includes('edit')}
                        suppressContentEditableWarning={true}
                        onBlur={(e) =>
                            actionsForPage.includes('edit') &&
                            handleEdit(row.ServiceID, 'ServiceName', e.target.textContent)
                        }
                    >
                        {row.ServiceName}
                    </td>

                    {/* Editable Category Selection */}
                    <td>
                        {actionsForPage.includes('edit') ? (
                            <select
                                className="default-select form-control mt-2 ms-1"
                                name="categoryId"
                                defaultValue={row.category.categoryName}
                                onBlur={(e) =>
                                    handleEdit(row.ServiceID, 'categoryId', e.target.value)
                                }
                            >
                                <option data-display="Select">{row.category.categoryName}</option>
                                {categories.map((cat) => (
                                    <option key={cat.servicecategoryID} value={cat.servicecategoryID}>
                                        {cat.categoryName}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <span>{row.category.categoryName}</span>
                        )}
                    </td>

                    {/* Editable Standard Price */}
                    <td
                        contentEditable={actionsForPage.includes('edit')}
                        suppressContentEditableWarning={true}
                        onBlur={(e) =>
                            actionsForPage.includes('edit') &&
                            handleEdit(row.ServiceID, 'StandardPrice', e.target.textContent)
                        }
                    >
                        {row.StandardPrice}
                    </td>

                    {/* Editable Estimated Time */}
                    <td
                        contentEditable={actionsForPage.includes('edit')}
                        suppressContentEditableWarning={true}
                        onBlur={(e) =>
                            actionsForPage.includes('edit') &&
                            handleEdit(row.ServiceID, 'EstimatedTime', e.target.textContent)
                        }
                    >
                        {row.EstimatedTime}
                    </td>

                    {/* Status Dropdown */}
                    <td>
                        {actionsForPage.includes('edit') ? (
                            <Dropdown
                                onSelect={(eventKey) =>
                                    handleSelect(eventKey, key)
                                }
                            >
                                <Dropdown.Toggle
                                    id="statusDropdown"
                                    as="div"
                                    className={`btn ${
                                        row.Status === "Available"
                                            ? "btn-success"
                                            : "btn-danger"
                                    }`}
                                >
                                    {row.Status === "Available"
                                        ? "متوفر"
                                        : "غير متوفر"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="Available">
                                        متوفر
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey="Unavailable">
                                        غير متوفر
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        ) : (
                            <span
                                className={`badge ${
                                    row.Status === "Available"
                                        ? "bg-success"
                                        : "bg-danger"
                                }`}
                            >
                                {row.Status === "Available"
                                    ? "متوفر"
                                    : "غير متوفر"}
                            </span>
                        )}
                    </td>
                </tr>
            ))}
    </tbody>
</table>

                        </div>
                    </div>
                </div>
            </Modal>
        </>

    );
});

export default ServiceModal;
